import { isSettingsOrderConfigEnabled } from '@/actions-permission/settings.permissions'

const routeOrderConfig = store => ({
  path: 'order-config',
  name: 'order-config',
  component: () =>
    import(
      /* webpackChunkName: "orderconfig" */ '@/views/Settings/OrderConfig.vue'
    ),
  beforeEnter: (to, from, next) => {
    if (!isSettingsOrderConfigEnabled(store.getters.permissionIsEnabled)) {
      return store.commit('toggleGlobalError', { status: true, code: 404 })
    }
    next()
  },
  meta: {
    breadcrumb: {
      refer: 'breadcrumb.settings.root',
      current: 'breadcrumb.settings.order'
    }
  }
})

export default routeOrderConfig
